module.exports = __webpack_public_path__ + "static/media/genset.204bbbce.jpg";